import { useMemo } from "react"
import styled from "styled-components"
import { theme } from "../../../../styles/theme"
import { useGetStBreak, useGetStObject, useGetStSpeed, useGetStDetection, useGetStSigLdws, useGetStSigBreak } from "../../../../api/st"
import { GetStParams } from "../../../../types"
import { Chart_Stat } from "../../../Chart/Stat"

interface ApiTarget {
  partName: string,
  groupName: string,
  driveNumber: string,
}
interface Props {
  apiTarget: ApiTarget,
  startDate: string,
  endDate: string,
}

export const Section_History_StatCharts = ({apiTarget, startDate, endDate}: Props) => {
  const
  getStParams = useMemo(() => {
    const result: GetStParams = {
      ...apiTarget,
      startDate,
      endDate,
    }

    return result
  }, [apiTarget, startDate, endDate]),
  {data: stSpeed} = useGetStSpeed(getStParams),
  {data: stObject} = useGetStObject(getStParams),
  {data: stBreak} = useGetStBreak(getStParams),
  {data: stDetection} = useGetStDetection(getStParams),
  {data: stSigLdws} = useGetStSigLdws(getStParams),
  {data: stSigBreak} = useGetStSigBreak(getStParams)
  /**
   * TS
   * 제외[차선 이탈 감지 횟수]
   */
  return (
    <SSection>
      <ul>
        <li>
          <label>- 물체가 감지 되었을 상황에서의 평균속도</label>
          <div className="chart"><Chart_Stat.Doughnut type="speed" data={stSpeed} /></div>
        </li>
        <li>
          <label>- 물체가 감지 되었을 상황에서의 브레이크 횟수</label>
          <div className="chart"><Chart_Stat.Bar type="break" data={stBreak} /></div>
        </li>
        <li>
          <label>- 감지된 물체</label>
          <div className="chart"><Chart_Stat.Doughnut type="object" data={stObject} /></div>
        </li>
        <li>
          <label>- 차량 속도별 물체 감지 횟수</label>
          <div className="chart"><Chart_Stat.Line type="detection" data={stDetection} /></div>
        </li>
        <li>
          <label>- 방향지시등 작동 이후 알람 받아 시그널입력기상 브레이크등 작동한 횟수</label>
          <div className="chart"><Chart_Stat.Doughnut type="sigBreak" data={stSigBreak} /></div>
        </li>
      </ul>
    </SSection>
  )
}

const SSection = styled.section`
  background-color: ${theme.colors.black_bg};
  border-radius: 8px;
  padding: 16px;

  & > ul {
    padding: 10px;

    & > li {
      min-width: 300px;
      margin-bottom: 30px;

      & > label {
        display: block;
        font-weight: 600;
        margin-bottom: 10px;
      }
      & > .chart {
        & > canvas {
          width: 100%;
          max-width: 100%;
          height: 300px;
        }
      }
    }
  }
`